// extracted by mini-css-extract-plugin
export default {"back":"Spinner_back__gbIa4","loaders":"Spinner_loaders__QcQi5","loaderss":"Spinner_loaderss__dyg+s"};